<div id="terms" fxLayout="column" linPerfectScrollbar>
  <div id="terms-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
    <div id="terms-form">
      <div class="logo">
        <img [src]="(platformSettings$ | async)?.logoUrl" />
      </div>
      <!-- <div class="title">{{ 'TERMS_OF_USE.TITLE' | translate }}</div> -->
      <div class="description">{{ 'TERMS_OF_USE.DESCRIPTION' | translate }}</div>
      <form [formGroup]="form" (ngSubmit)="submitForm()">
        <mat-checkbox class="checkbox" formControlName="tos" (click)="checkCheckbox($event, 'tos')">
          {{ 'TERMS_OF_USE.AGREEMENT' | translate }}
          <a (click)="openLink('tos'); false">{{ 'TERMS_OF_USE.TERMS_OF_SERVICE' | translate }}</a>
        </mat-checkbox>
        <span [style.visibility]="getCheckboxErrorState('tos') ? 'visible' : 'hidden'" class="error">
          {{ 'TERMS_OF_USE.MUST_READ' | translate:{ value: ('TERMS_OF_USE.TERMS_OF_SERVICE' | translate) } }}
        </span>

        <mat-checkbox class="checkbox" formControlName="pp" (click)="checkCheckbox($event, 'pp')">
          {{ 'TERMS_OF_USE.AGREEMENT' | translate }}
          <a (click)="openLink('pp'); false">{{ 'TERMS_OF_USE.PRIVACY_POLICY' | translate }}</a>
        </mat-checkbox>
        <span [style.visibility]="getCheckboxErrorState('pp') ? 'visible' : 'hidden'" class="error">
          {{ 'TERMS_OF_USE.MUST_READ' | translate:{ value: ('TERMS_OF_USE.PRIVACY_POLICY' | translate) } }}
        </span>

        <div class="form-footer" fxLayout="column" fxLayoutAlign="center center">
          <lin-form-submit-button [isLoading]="isSubmitting"> {{ 'BUTTONS.CONTINUE' | translate }} </lin-form-submit-button>
        </div>
      </form>
    </div>
  </div>
</div>
